import { action, createRequestTypes } from './base';

export const categoryActionTypes = {
  CREATE_CATEGORY: createRequestTypes('CREATE_CATEGORY'),
  GET_CATEGORIES: createRequestTypes('GET_CATEGORIES'),
  UPDATE_CATEGORY: createRequestTypes('UPDATE_CATEGORY'),
  DELETE_CATEGORY: createRequestTypes('DELETE_CATEGORY'),
  CREATE_SUB_CATEGORY: createRequestTypes('CREATE_SUB_CATEGORY'),
  GET_SUB_CATEGORIES: createRequestTypes('GET_SUB_CATEGORIES'),
};

/**
 *
 */
class CategoryActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createCategory = (payload, callback) => action(categoryActionTypes.CREATE_CATEGORY.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createCategoryLoading
   * @return {{type: *}}
   */
  createCategoryLoading = (createCategoryLoading) => action(categoryActionTypes.CREATE_CATEGORY.LOADING, {
    createCategoryLoading,
  })

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param searchKeyword
   * @return {{type: *}}
   */
  getCategories = (orgId, page, limit, searchKeyword) => action(categoryActionTypes.GET_CATEGORIES.REQUEST, {
    orgId,
    page,
    limit,
    searchKeyword,
  })

  /**
   *
   * @param getCategoriesLoading
   * @return {{type: *}}
   */
  getCategoriesLoading = (getCategoriesLoading) => action(categoryActionTypes.GET_CATEGORIES.LOADING, {
    getCategoriesLoading,
  })

  /**
   *
   * @param categories
   * @return {{type: *}}
   */
  getCategoriesSuccess = (categories) => action(categoryActionTypes.GET_CATEGORIES.SUCCESS, {
    categories,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateCategory = (payload, callback) => action(categoryActionTypes.UPDATE_CATEGORY.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateCategoryLoading
   * @return {{type: *}}
   */
  updateCategoryLoading = (updateCategoryLoading) => action(categoryActionTypes.UPDATE_CATEGORY.LOADING, {
    updateCategoryLoading,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteCategory = (payload, callback) => action(categoryActionTypes.DELETE_CATEGORY.REQUEST, {
    payload, callback,
  })

  /**
   * @param deleteCategoryLoading
   * @return {{type: *}}
   */
  deleteCategoryLoading = (deleteCategoryLoading) => action(categoryActionTypes.DELETE_CATEGORY.LOADING, {
    deleteCategoryLoading,
  })

  // create sub category
  createSubCategory = (payload, callback) => action(categoryActionTypes.CREATE_SUB_CATEGORY.REQUEST, {
    payload,
    callback,
  })

  createSubCategoryLoading = (createSubCategoryLoading) => action(categoryActionTypes.CREATE_SUB_CATEGORY.LOADING, {
    createSubCategoryLoading,
  })

  // get sub category

  getSubCategories = (searchKeyword, page, limit) => action(categoryActionTypes.GET_SUB_CATEGORIES.REQUEST, {
    searchKeyword,
    page,
    limit,
  })

  getSubCategoriesLoading = (getSubCategoriesLoading) => action(categoryActionTypes.GET_SUB_CATEGORIES.LOADING, {
    getSubCategoriesLoading,
  })

  getSubCategoriesSuccess = (subCategories) => action(categoryActionTypes.GET_SUB_CATEGORIES.SUCCESS, {
    subCategories,
  })
}

export default new CategoryActions();
